import { instana } from "@crystal/analytics";
import "@crystal/core";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import { getHostInfo } from "../store/state/getters.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import { getRuntimeInfo } from "../integration/state-getters.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import { Events } from "../monitoring.js";
import "../ap2/config.js";
import "../ap2/state.js";
import { createKmcStarter } from "./kmc.js";
import { saveAuthFlow } from "./persistence.js";
import { createSocialLoginStarter } from "./social-login.js";
import "../config/source-ids.js";
import "../config/presets.js";
import { getUniversalAuthParams } from "../config/universal-auth.js";
function startExternalAuthFlow(flow) {
  let { transitData } = flow;
  const { context } = getHostInfo();
  const { pageContext, isAuthProvider } = getRuntimeInfo();
  if (isAuthProvider && !(transitData == null ? void 0 : transitData.isAuthProvider)) {
    const { redirectUri, state, clientId } = getUniversalAuthParams();
    transitData = {
      ...transitData,
      isAuthProvider: true,
      clientId,
      redirectUri,
      state
    };
  }
  const redirectRoute = flow.authContext.redirectRoute || (pageContext == null ? void 0 : pageContext.originRoute);
  let defaultOriginApp;
  if (!isAuthProvider && !redirectRoute) {
    defaultOriginApp = {
      path: window.location.pathname
    };
  }
  const authFlow = {
    ...flow,
    transitData,
    pageContext: {
      ...pageContext,
      originApp: (pageContext == null ? void 0 : pageContext.originApp) || defaultOriginApp
    }
  };
  saveAuthFlow(authFlow);
  const starter = getStarter(authFlow, context);
  starter.startAuthFlow();
  instana("reportEvent", Events.PortalClosed);
}
function getStarter(flow, context) {
  switch (flow.method) {
    case "kmc":
      return createKmcStarter(flow, context);
    case "social-login":
      return createSocialLoginStarter(flow, context);
  }
}
export {
  startExternalAuthFlow
};
//# sourceMappingURL=starter.js.map
